export default __webpack_public_path__ + "static/media/ecoLocation3.d4e39a58.png";